






import { Vue, Component, Prop } from 'vue-property-decorator'

@Component({
  components: {
    loading: () => import('./Index.vue')
  }
})
export default class UploadLoading extends Vue {}
